import axios from "axios";

export const rephrasePrompt = async (query: string, conversation_id: string | undefined) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await axios.post(
    `${import.meta.env.VITE_API_URL}/rephrase`,
    { query, conversation_id },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};